import React, { Fragment, useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { sanitizeHtml } from "../../utils/sanitize";
import moment from "moment";

import { useAlert } from "react-alert";

import { getSingleNews } from "./../../actions/newsActions";
import Loader from "../Loader";
import { newsImageUrl } from "../../utils/assets";

import "./NewsDetail.css";

const NewsDetail = ({ history, match }) => {
  const alert = useAlert();
  const dispatch = useDispatch();

  const { user, isAuthenticated } = useSelector((state) => state.auth);

  const currentId = match.params.id;
  useEffect(() => {
    dispatch(getSingleNews(currentId));
  }, [dispatch, currentId]);

  const { newsDetail, nloading } = useSelector((state) => state.singleNews);

  // Format date nicely
  const formatDate = (dateStr) => {
    if (!dateStr) return "";
    return moment(dateStr).format("MMMM DD, YYYY");
  };

  return (
    <Fragment>
      <section
        className="page-banner-sec text-center"
        style={{
          backgroundImage: `url("/assets/frontend/img/about-banner.jpg")`,
        }}
      >
        <div className="container">
          <ul className="clearfix paginations-cust">
            <li>
              <Link to="/">Home</Link>
            </li>
            <li>
              <Link to="/news">News</Link>
            </li>
          </ul>
          <h1>News Details</h1>
        </div>
      </section>

      <section className="news-detail-sec">
        <div className="container">
          {nloading ? (
            <Loader />
          ) : newsDetail && newsDetail._id ? (
            <div className="news-detail-wrapper">
              {/* News Image */}
              <div className="news-detail-image">
                <img
                  src={newsImageUrl(newsDetail.logo)}
                  alt={newsDetail.title || "News Image"}
                  onError={(e) => {
                    e.target.onerror = null;
                    e.target.src = "/assets/frontend/img/about-banner.jpg";
                  }}
                />
              </div>

              {/* News Header */}
              <div className="news-detail-header">
                <div className="news-meta">
                  <span className="news-author">
                    <i className="fa fa-user"></i> By Admin
                  </span>
                  <span className="news-date">
                    <i className="fa fa-calendar"></i> {formatDate(newsDetail.createdAt)}
                  </span>
                </div>
                <h1 className="news-title">{newsDetail.title}</h1>
              </div>

              {/* News Content */}
              <div 
                className="news-detail-content"
                dangerouslySetInnerHTML={{ __html: sanitizeHtml(newsDetail.description) }}
              />
            </div>
          ) : (
            <div className="text-center" style={{ padding: "50px" }}>
              <p>News article not found.</p>
              <Link to="/news" className="btn btn-primary">Back to News</Link>
            </div>
          )}
        </div>
      </section>
    </Fragment>
  );
};

export default NewsDetail;
